import React from 'react';
import Header from '../../components/common/Header';
import HeroCarousel from '../../components/sections/HeroCarousel';
import Footer from '../../components/common/Footer';
import SEOHelmet from '../../components/common/SEOHelmet';

// Import with direct path to avoid index.js issues
import WelcomeSection from '../../components/sections/WelcomeSection/WelcomeSection';


const Home = () => {
  return (
    <div className="home-page">
      <SEOHelmet 
        title="Siridharini - Sustainable Agricultural Investment | Money Does Grow On Trees"
        description="Invest in premium sustainable farmland near Bangalore. Sandalwood, teak wood, and organic farming with guaranteed returns. Managed farmland investment opportunities."
        keywords="agricultural investment, managed farmland Bangalore, sandalwood investment, teak wood farming, sustainable agriculture, farm investment India, organic farming returns"
        url="https://siridharini.com"
      />
      <Header />
      <HeroCarousel />
      <WelcomeSection />
      <Footer />
    </div>
  );
};
export default Home;